module.exports = __webpack_public_path__ + "static/media/JBHUNT-logo.ff825fba.svg";